import React, { useState, useEffect } from "react";
import { Box, Heading, Button, Flex, Text, Alert, AlertIcon } from "@chakra-ui/react";
import { fetchAuthUrl, checkGoogleDriveAuth } from "../../api/google";

function GoogleDriveAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const result = await checkGoogleDriveAuth();
      setIsAuthenticated(result.authenticated);
    } catch (err) {
      setIsAuthenticated(false);
    }
    setLoading(false);
  };

  const initiateAuth = async () => {
    try {
      setLoading(true);
      const response = await fetchAuthUrl();
      // Redirect to Google's OAuth consent screen
      window.location.href = response.authUrl;
    } catch (err) {
      setError("Failed to initiate authentication");
      setLoading(false);
    }
  };

  return (
    <Flex justify="center" align="center" minH="100vh">
      <Box maxW="md" w="full" p={8}>
        <Heading size="lg" mb={4}>Google Drive Integration</Heading>

      {!isAuthenticated ? (
        <Button
          onClick={initiateAuth}
          colorScheme="blue"
          isLoading={loading}
          loadingText="Connecting..."
        >
          Connect to Google Drive
        </Button>
      ) : (
        <Box>
          <Flex align="center" mb={4}>
            <Text mr={4} color="green.600">✓ Connected to Google Drive</Text>
          </Flex>
        </Box>
      )}

      {error && (
        <Alert status="error" mt={4}>
          <AlertIcon />
          {error}
        </Alert>
      )}
      </Box>
    </Flex>
  );
}

export default GoogleDriveAuth;
